<div
  class="ds-state-block"
  [class.is-bordered]="bordered"
  [class.is-error]="tone === 'error'"
  [class.is-empty]="tone === 'empty'"
>
  <ng-content></ng-content>
  @if (message) {
    {{ message }}
  }
</div>
